<template>
  <div class="row" :class="errorClass">
    <div class="col-md-4 col-lg-4 col-xl-3">
      <label class="h6 text-md-right">
        <span v-html="label"></span> <br>
        <small class="text-black-50">{{labelSecondary}}</small>
      </label>
    </div>
    <div class="col-md-8 col-lg-8 col-xl-9">
      <div class="d-flex">
        <h6 class="w-50"><strong>Value</strong></h6>
        <h6 class="w-50"><strong>Behaviour</strong></h6>
      </div>
      <div class="d-flex align-items-center border rounded p-2 mb-3" style="border-color: deeppink !important">
        <div class="form-check w-50">
          <input class="form-check-input" v-b-tooltip.hover :title="values[0].tooltip" v-on:change="checkboxChanged" type="checkbox" v-model="values[0].value" :id="values[0].name" :value="values[0].value">
          <label class="form-check-label" v-b-tooltip.hover :title="values[0].tooltip" :for="values[0].name">{{values[0].name}}</label>
        </div>
        <div class="w-50">
          <div v-for="behaviour in behaviours.slice(0,3)" v-bind:key="behaviour.name" class="form-check">
            <input class="form-check-input" v-on:change="checkboxChanged" type="checkbox" v-model="behaviour.value" :id="behaviour.name" :value="behaviour.value">
            <label class="form-check-label" :for="behaviour.name">{{behaviour.name}}</label>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center border rounded p-2 mb-3" style="border-color: purple !important">
        <div class="form-check w-50">
          <input class="form-check-input" v-b-tooltip.hover :title="values[1].tooltip" v-on:change="checkboxChanged" type="checkbox" v-model="values[1].value" :id="values[1].name" :value="values[1].value">
          <label class="form-check-label" v-b-tooltip.hover :title="values[1].tooltip" :for="values[1].name">{{values[1].name}}</label>
        </div>
        <div class="w-50">
          <div v-for="behaviour in behaviours.slice(3,6)" v-bind:key="behaviour.name" class="form-check">
            <input class="form-check-input" v-on:change="checkboxChanged" type="checkbox" v-model="behaviour.value" :id="behaviour.name" :value="behaviour.value">
            <label class="form-check-label" :for="behaviour.name">{{behaviour.name}}</label>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center border rounded p-2 mb-3" style="border-color: darkturquoise !important">
        <div class="form-check w-50">
          <input class="form-check-input" v-b-tooltip.hover :title="values[2].tooltip" v-on:change="checkboxChanged" type="checkbox" v-model="values[2].value" :id="values[2].name" :value="values[2].value">
          <label class="form-check-label" v-b-tooltip.hover :title="values[2].tooltip" :for="values[2].name">{{values[2].name}}</label>
        </div>
        <div class="w-50">
          <div v-for="behaviour in behaviours.slice(6,9)" v-bind:key="behaviour.name" class="form-check">
            <input class="form-check-input" v-on:change="checkboxChanged" type="checkbox" v-model="behaviour.value" :id="behaviour.name" :value="behaviour.value">
            <label class="form-check-label" :for="behaviour.name">{{behaviour.name}}</label>
          </div>
        </div>
      </div>
      <div class="d-flex mt-2">
        <h6 class="w-50" :class="valuesSelected.class">Values selected: <strong>{{valuesSelected.count}}</strong></h6>
        <h6 class="w-50" :class="behavioursSelected.class">Behaviours selected: <strong>{{behavioursSelected.count}}</strong></h6>
      </div>
      <div v-if="errorClass !== ''" class="alert alert-danger mt-1" role="alert">
        Please tick the required number of checkboxes
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'label',
    'labelSecondary',
    'isRequired',
    'errorClass'
  ],
  data () {
    return {
      values: [
        {name: 'Care', value: false, tooltip: 'CARE is all about doing what’s best for everyone – ourselves, our colleagues, and most importantly, every customer. It’s about showing true CHARACTER, especially when we’re under pressure. It’s about being CONSIDERATE of others, showing respect at all times. And it’s about CONTRIBUTING in any way you can to make this the best company to work for.'},
        {name: 'Connect', value: false, tooltip: 'The value of CONNECT underpins our commitment to getting closer to our subscribers, employees, and communities so that we know how to enrich their lives and give them what they need before they even realize they need it. CONNECTING is about making our circle bigger— developing networks and collaborating with others to co-create solutions and achieve shared goals. To truly CONNECT with others means to share ideas and experience, to involve others and really listen to their suggestions and opinions, and to keep others in the loop—informing them, educating them, empowering them. Complexity is the enemy of CONNECTING, so we strive to communicate clearly and keep our products and services simple and easy to use.'},
        {name: 'Create', value: false, tooltip: 'The CREATE value represents our determination to continuously reinvent ourselves to remain innovative, competitive, relevant, and edgy. CREATING doesn’t stem from simply being creative. It is sparked by exploring fresh ways of doing things and having the courage and commitment to implement and embrace the new. Living the CREATE value entails always being on the lookout for new ways to enrich the lives of our customers, employees and society in general. We can only CREATE amazing experiences when we think way out of the box, get comfortable with taking risks, and adopt a ‘can do’ attitude.'}
      ],
      behaviours: [
        {name: 'Character', value: false},
        {name: 'Consideration', value: false},
        {name: 'Contribution', value: false},
        {name: 'Collaboration', value: false},
        {name: 'Communication', value: false},
        {name: 'Clarity', value: false},
        {name: 'Curiosity', value: false},
        {name: 'Courage', value: false},
        {name: 'Commitment', value: false}
      ]
    }
  },
  computed: {
    valuesSelected: function () {
      let notificationClass = 'warningColor'
      let selected = this.values.filter(x => x.value).length
      if (selected > 0) {
        notificationClass = 'successColor'
      }
      return {class: notificationClass, count: selected}
    },
    behavioursSelected: function () {
      let notificationClass = 'warningColor'
      let selected = this.behaviours.filter(x => x.value).length
      if (selected > 0) {
        notificationClass = 'successColor'
      }
      return {class: notificationClass, count: selected}
    }
  },
  methods: {
    setSelectedCountClass: function (count) {
      if (count < 5 && count > 0) {
        return 'warningColor'
      } else if (count <= 0) {
        return 'successColor'
      } else {
        return ''
      }
    },
    formatCheckBoxContent: function () {
      var formattedContent = '<ul>'
      for (var k = 0; k < this.values.length; k++) {
        if (this.values[k].value) {
          formattedContent += '<li>Value: ' + this.values[k].name + '</li>'
        }
      }
      for (var l = 0; l < this.behaviours.length; l++) {
        if (this.behaviours[l].value) {
          formattedContent += '<li>Behaviour: ' + this.behaviours[l].name + '</li>'
        }
      }
      return formattedContent + '</ul>'
    },
    checkboxChanged: function () {
      this.$emit('addedCheckBoxesContent', {
        label: this.label,
        content: this.formatCheckBoxContent(),
        validated: this.valuesSelected.count > 0 && this.behavioursSelected.count > 0
      })
    }
  }
}
</script>

<style lang="less">
  .warningColor {
    color: red !important;
  }
  .successColor {
    color: green !important;
  }
  label {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/FieldCheckBoxesCharacteristics.vue